<script lang="ts">
      import MenuArrow from '$lib/components/menu/MenuArrow.svelte'
      import BlockHeading from '$lib/components/ui/BlockHeading.svelte'
      import { delay, flipAnimation, renderTick } from '$lib/utils/flip'
      import { onMount } from 'svelte'
      import { on } from 'svelte/events'

      let bubble = false

      async function handleOnclick(this: HTMLElement, ev: Event) {
            if (bubble) return
            //const target = this
            const target = menu
            if (!target) return
            bubble = true

            if (open) await delay(120)
            const animation = await flipAnimation(target as HTMLElement, flip, { duration: 234 })

            await animation.finished

            bubble = false
      }

      function flip() {
            open = !open
      }

      onMount(() => {
            const ctrl = new AbortController()
            on(
                  window,
                  'scroll',
                  () => {
                        if (open) handleOnclick()
                  },
                  { signal: ctrl.signal }
            )

            return () => {
                  ctrl.abort()
            }
      })

      let open = $state(false)
      let menu: HTMLElement

      let { children = undefined, menuItems = undefined } = $props()
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div onmouseup={handleOnclick} ontouchend={handleOnclick} class="{open ? 'open' : ''}  holder sticky top-[3.2rem] z-[1]">
      <div class="pill-container relative z-[100] mx-auto md:mx-[unset] w-max rounded-full px-8 overflow-hidden flex items-center">
            <div class="w-full h-full pill absolute top-0 left-0 z-[-1] opacity-100"></div>

            <BlockHeading class="capitalize my-3 select-none text-lg">
                  {@render children?.()}
            </BlockHeading>
            <MenuArrow {open} class="h-[1rem] aspect-square fill-[var(--df-primary)]"></MenuArrow>
      </div>
      <div bind:this={menu} class="menu w-full absolute top-[110%] left-0 h-0 overflow-hidden grid col-span-1 z-[100]">
            <div class="w-full h-full grid grid-cols-1 relative z-[1000]">
                  {@render menuItems?.()}
            </div>
      </div>
</div>

<style lang="postcss">
      .pill {
            @apply select-none;
            backdrop-filter: blur(20px);
            background-color: #ffffffcc;
      }

      .pill-container {
            width: max-content;
            box-shadow:  0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1), 0 0px 20px 10px #8f8f8f15;
      }
      .pill-container:global(.open) {
            width: 100%;
      }

      .menu {
            @apply rounded-3xl shadow-md;
            backdrop-filter: blur(20px);
            background-color: #ffffffcc;
      }

      .holder:global(:not(.open)) .menu {
            height: 0rem;
      }

      .holder:global(.open) .menu {
            height: auto;
      }

      :global(.filter-bar):has(.holder:global(.open)) {
        @apply z-[100];
      }
</style>
